<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="row" v-if="notifications">
        <div class="col-12" id="notifications">
               <div class="headline col-12 mb-0" style="font-weight: 500 !important;">  {{$t('notifications.management')}} </div>
             <v-data-table hide-default-footer hide-default-header :headers="headers" :items="notifications" class="elevation-1" :loading="!notifications">
                <template v-slot:item._content="{item}" :style="{background: item._state ? '#dddddd' : ''}">
                    <span style="color: #29b3a6"> 
                        <span class="badge" :class="item._env==='sandbox' ? 'badge-warning' : (item._env==='live' ? 'badge-success' : 'badge-info')">{{item._env && item._env!==null ? item._env : 's-l'}}</span>
                         {{item._title}}</span>
                          <span class="badge badge-light float-right">{{ item._type }}</span>
                    <br>
                    <span> <small>  {{getDate(item._created_at)}} </small></span>
                     <br> 
                     <span>{{item._content}}</span>
                </template>
                </v-data-table>
                <div class="text-right col-12">
                    <v-pagination
                    elevation="0"
                    v-model="page"
                    :length="total_pages"
                    :total-visible="7"
                    prev-icon="mdi-menu-left"
                    next-icon="mdi-menu-right"
                    @input="getpaginateNotifications"
                    ></v-pagination>
            </div>
            <!-- <v-alert
                        style="margin-top: 1%"
                        v-if="notifications==undefined || notifications.length==0"
                        border="right"
                        colored-border
                        type="error"
                        elevation="2"
                >
                    {{$t('notifications.empty')}}
                </v-alert> -->
        </div>
    </div>
    <div v-else class="col-lg-12 col-md-12 col-12 text-center loader_panel_component">
        <img v-lazy="'/loaders/loader_turq.gif'" alt="" width="50px"><br>
        <span class="loader_text"> Chargement en cours ... </span>
    </div>
</template>

<script>
    /* eslint-disable */
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import CountryFlag from 'vue-country-flag'
    import helpers from "../../mixins/helpers";
    import countries from '../../resources/countries.json'
    import $ from 'jquery'
    export default {
        components: {
            CountryFlag
        },
        mixins: [helpers(this)],
        label: "Notifications",
        data() {
            return {
                submitting: false,
                valid: true,
                lazy: false,
                search: '',
                dialog: false,
                id: undefined,
                errors: undefined,
                total_pages:0,
                page:1,
                editedIndex: -1,
                headers: [
                    {text: 'Content', value: '_content'},
                   
                ],

            }
        },
        computed: {
            ...mapState('notifications/', ['notifications']),
            ...mapState('marchands/',['marchandu'])
        },
        mounted() {
            this.$vuetify.goTo(0)
            $(document).scrollTop()
            let data={
                page:(this.page-1),
                marchand_id:this.$store.getters.marchand._id
            },
            vbox=this;
            this.$store.dispatch('notifications/getNotifications',data).then(response => {
                vbox.page=response.page+1
                vbox.total_pages=response.total_pages
            });
        },
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            getpaginateNotifications(page){
                    let data={
                    page:(page-1),
                    marchand_id:this.$store.getters.marchand._id
                },
                vbox=this;
                this.$store.dispatch('notifications/getNotifications',data).then(response => {
                    vbox.page=response.page+1
                    vbox.total_pages=response.total_pages
                });
            },
            getformatDate(value) {
                if (value) {
                    return Intl.DateTimeFormat('fr-FR', {
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit',
                        hour: "numeric",
                        minute: "2-digit",
                        second: "2-digit"
                    }).format(new Date(value));
                }
            },
            checkIfExist() {
                let VueBox = this;
                if (VueBox.editedIndex > -1) {
                    return VueBox.countries.find(value => value._code === VueBox.editedItem.code && value._id !== VueBox.editedItem._id)
                } else {
                    return VueBox.countries.find(value => value._code === VueBox.editedItem.code)
                }
            },
            getColor(calories) {
                if (calories > 230) return 'red'
                else if (calories > 200) return 'orange'
                else return 'green'
            },
            setCountryDetails(){
                let country =  countries.find(country=> country.iso2 == this.editedItem._code);
                this.editedItem._name = country.name;
                this.editedItem._code_iso_numerique = country.phone_code;
            },

        },

        created() {
            this.checkisDashboard();
        }
    }
</script>

<style>
#notifications .v-data-table > .v-data-table__wrapper > table > tbody > tr > td{
    padding:20px
}
</style>
